import React, { useState, useEffect } from 'react';
import Loader from './Loader';
import axios from 'axios';
import params from '../config/Params';
import { getItemFromLocalStorage } from '../utils/storageUtils';
import { toast } from 'react-toastify';
import LoadingDots from './LoadingDots';

const ListingStep5 = ({ formData, handleChange, prevStep, onRegisterSave }) => {
  const min = 1;
  const max = 50;
  const guestMax = 16;

  const { listingId } = formData;
  const [listingData, setListingData] = useState([]);
  const [guests, setGuests] = useState(1);
  const [beds, setBeds] = useState(1);
  const [bedrooms, setBedrooms] = useState(1);
  const [bathrooms, setBathrooms] = useState(1);
  const [question, setQuestion] = useState([]);
  const [activeIndex, setActiveIndex] = useState(null);
  const [nextLoading, setNextLoading] = useState(false);
  const [loading, setLoading] = useState(true);

  const handleDecrement = (value, setValue, minLimit = 1) => {
    if (value > minLimit) {
      setValue(value - 1);
    }
  };

  const handleIncrement = (value, setValue, maxLimit = 50) => {
    if (value < maxLimit) {
      setValue(value + 1);
    }
  };

  const handleInputChange = (e, setValue, minLimit = 1, maxLimit = 50) => {
    const newValue = Number(e.target.value);
    if (newValue >= minLimit && newValue <= maxLimit) {
      setValue(newValue);
    }
  };

  useEffect(() => {

    const fetchListingData = async () => {
      const hostData = getItemFromLocalStorage('hostProfile');
      let formData = new FormData();
      formData.append('token', hostData.host_access_token);
      formData.append('listing_id', listingId);

      try {
        const response = await axios({
          method: 'post',
          headers: {
            'Content-Type': 'multipart/form-data',
          },
          url: `${params.baseURL}${params.endpoints.getListingData}`,
          data: formData,
        });

        if (response.data.status === 'ok') {
          const listingData = response.data.updated_property_item;
          const { appr_list, resrv_list, offers, place_options_list } = listingData;
          setListingData(response.data.updated_property_item);
          setQuestion(response.data.updated_property_item.questions);

          setGuests(response.data.updated_property_item.no_of_guests || 1);
          setBeds(response.data.updated_property_item.no_of_beds || 1);
          setBathrooms(response.data.updated_property_item.no_of_bathrooms || 1);
          setBedrooms(response.data.updated_property_item.no_of_bedrooms || 1);

          setLoading(false);
        } else {
          toast.error('An error occurred while fetching data.');
        }
      } catch (err) {
        console.log(err.message);
        setLoading(false);
      } finally {
        setLoading(false);
      }
    };

    fetchListingData();
  }, []);


  const saveListing = async () => {
    const hostData = getItemFromLocalStorage('hostProfile');
    const listing_id = listingId;
    const ts = Date.now();

    const updatedPropertyItem = {
      no_of_guests: guests,
      no_of_beds: beds,
      no_of_bedrooms: bedrooms,
      no_of_bathrooms: bathrooms,
    };

    const mergedData = { ...listingData, ...updatedPropertyItem };

    let catData = new FormData();
    catData.append('token', hostData.host_access_token);
    catData.append('listing_id', listing_id);
    catData.append('data', JSON.stringify(mergedData));
    catData.append('ts', ts);

    setNextLoading(true);

    try {
      const response = await axios({
        method: 'post',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        url: `${params.baseURL}${params.endpoints.updateListing}`,
        data: catData,
      });

      if (response.data.status === 'done') {
        return true;
      } else {
        toast.error('Failed to save data');
        return false;
      }
    } catch (err) {
      toast.error('An error occurred while saving the listing');
      return false;
    }
  };



  const faqs = [
    {
      question: "What is Lorem Ipsum?",
      answer: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book."
    },
    {
      question: "Where does it come from?",
      answer: "Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old."
    },
  ];

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  if (loading) {
    return (
      <Loader />
    );
  }

  return (
    <div className="fade-in">
      <button id='host-listing-trigger-5' style={{ display: 'none' }} onClick={() => {
        if (onRegisterSave) {
          onRegisterSave(saveListing);
        }
      }}>Done</button>
      <div className='row'>
        {/*<div className='col-md-4 listing-img-box'>
          <div className='lsib'>
            <img src={'/assets/img/listing/listing_side_img.gif'} alt="Listing Image" className="listing-image" />
            {question && (
              <div className='lsqa-btn'>
                <StarButton text="Guide" link={question.find((q) => q.id === 5)?.link || '#'} />
              </div>
            )}
          </div>
        </div>*/}

        <div className='col-md-7'>

          <div className='ws-cl-header'>
            <div>
              <h4 className='ws-title'>Provide basic details here</h4>
              <p class="ws-desc">More specifics can be added later.</p>
            </div>
          </div>

          <div className='st1-desc-box'>
            <div className='gbbbb'>
              <div className='gbbb-icon-box'>
                <img src={'/assets/img/icons/guest_icon.svg'} alt='' className='img-fluid' />
                <label className='st1-label'>Guests</label>
              </div>
              <div className="input-number-container">
                <span
                  className={`input-number-decrement ${guests <= min ? 'disabled' : ''}`}
                  onClick={() => {
                    if (guests > min) handleDecrement(guests, setGuests, min);
                  }}
                >
                  –
                </span>
                <input
                  className="input-number"
                  type="number"
                  value={guests}
                  onChange={(e) => handleInputChange(e, setGuests, min, guestMax)}
                  min={min}
                  max={guestMax}
                  readOnly={true}
                />
                <span
                  className={`input-number-increment ${guests >= guestMax ? 'disabled' : ''}`}
                  onClick={() => {
                    if (guests < guestMax) handleIncrement(guests, setGuests, guestMax);
                  }}
                >
                  +
                </span>
              </div>
            </div>

            <div className='gbbbb'>
              <div className='gbbb-icon-box'>
                <img src={'/assets/img/icons/bed_icon.svg'} alt='' className='img-fluid' />
                <label className='st1-label'>Beds</label>
              </div>
              <div className="input-number-container">
                <span
                  className={`input-number-decrement ${beds <= min ? 'disabled' : ''}`}
                  onClick={() => {
                    if (beds > min) handleDecrement(beds, setBeds, min);
                  }}
                >
                  –
                </span>
                <input
                  className="input-number"
                  type="number"
                  value={beds}
                  onChange={(e) => handleInputChange(e, setBeds, min, max)}
                  min={min}
                  max={max}
                  readOnly={true}
                />
                <span
                  className={`input-number-increment ${beds >= max ? 'disabled' : ''}`}
                  onClick={() => {
                    if (beds < max) handleIncrement(beds, setBeds, max);
                  }}
                >
                  +
                </span>
              </div>
            </div>

            <div className='gbbbb'>
              <div className='gbbb-icon-box'>
                <img src={'/assets/img/icons/bedroom_icon.svg'} alt='' className='img-fluid' />
                <label className='st1-label'>Bedrooms</label>
              </div>
              <div className="input-number-container">
                <span
                  className={`input-number-decrement ${bedrooms <= min ? 'disabled' : ''}`}
                  onClick={() => {
                    if (bedrooms > min) handleDecrement(bedrooms, setBedrooms, min);
                  }}
                >
                  –
                </span>
                <input
                  className="input-number"
                  type="number"
                  value={bedrooms}
                  onChange={(e) => handleInputChange(e, setBedrooms, min, max)}
                  min={min}
                  max={max}
                  readOnly={true}
                />
                <span
                  className={`input-number-increment ${bedrooms >= max ? 'disabled' : ''}`}
                  onClick={() => {
                    if (bedrooms < max) handleIncrement(bedrooms, setBedrooms, max);
                  }}
                >
                  +
                </span>
              </div>
            </div>

            <div className='gbbbb'>
              <div className='gbbb-icon-box'>
                <img src={'/assets/img/icons/bathroom_icon.svg'} alt='' className='img-fluid' />
                <label className='st1-label'>Bathrooms</label>
              </div>
              <div className="input-number-container">
                <span
                  className={`input-number-decrement ${bathrooms <= min ? 'disabled' : ''}`}
                  onClick={() => {
                    if (bathrooms > min) handleDecrement(bathrooms, setBathrooms, min);
                  }}
                >
                  –
                </span>
                <input
                  className="input-number"
                  type="number"
                  value={bathrooms}
                  onChange={(e) => handleInputChange(e, setBathrooms, min, max)}
                  min={min}
                  max={max}
                  readOnly={true}
                />
                <span
                  className={`input-number-increment ${bathrooms >= max ? 'disabled' : ''}`}
                  onClick={() => {
                    if (bathrooms < max) handleIncrement(bathrooms, setBathrooms, max);
                  }}
                >
                  +
                </span>
              </div>
            </div>
          </div>

        </div>
        <div className='col-md-1'></div>
        <div className='col-md-4 p-0'>
          <div className='bfhsd'>
            <div className='blog-box'>
              <div class="blog">
                <div class="blog-image">
                  <img src={'https://app.wirestay.com/ws/uploads/blog/1736870810_pi.jpg'} className='img-fluid' alt="" />
                  <div class="date">May 08, 2025</div>
                </div>
                <div class="blog-content">
                  <h2>What is Lorem Ipsum?</h2>
                  <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris vel metus vel est fermentum consectetur.</p>
                  <a href="#">Read More</a>
                </div>
              </div>
            </div>
            <div className="faq-sticky">
              {faqs.map((faq, index) => (
                <div key={index} className='faqs-list-section'>
                  <div
                    onClick={() => toggleAccordion(index)} className='faqs-qustn-box'
                    style={{
                      backgroundColor: activeIndex === index ? "#f7f7f7" : "#ffffff",
                    }}
                  >
                    {faq.question}
                    <i
                      className={`fas ${activeIndex === index ? "fa-chevron-up" : "fa-chevron-down"
                        }`}
                      style={{
                        transition: "transform 0.3s ease",
                      }}
                    ></i>
                  </div>
                  {activeIndex === index && (
                    <div className='faqs-ans-box'>
                      {faq.answer}
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>

      </div>
    </div>
  );
};

export default ListingStep5;
